import moment from 'moment';

export const fechaFormat = (fecha) => {
    const formatted = moment(fecha)

    return formatted.format('HH:mm a | MMMM Do')
}